import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useThrottleFn } from 'react-use';

import { getLogger, tracker } from 'app-components/utils/core';

import BrowserMinVersion from 'components/BrowserMinVersion';
import BumpConnector from 'components/BumpConnector';

import ErrorBoundary from 'components/ErrorBoundary';
import MobileDirectDialog from 'components/MobileDirectDialog';
import StorageAccessChecker from 'components/StorageAccessChecker';
import TransactionsTTI from 'components/TransactionsTTI';
import FutureTransactionGuidedPopover from 'components/guides/FutureTransactionGuidedPopover';
import AchievementsNotifier from 'containers/App/AchievementsNotifier';
import ActionsSnackBar from 'containers/App/ActionsSnackBar';
import ContentSecurityPolicy from 'containers/App/ContentSecurityPolicy';
import Notifications from 'containers/App/Notifications';
import ShowPwaPrompts from 'containers/App/ShowPwaPrompts';
import UserIdle from 'containers/App/UserIdle';
import OfflineSnackbar from 'containers/OfflineSnackbar';
import SubscriptionMessaging from 'containers/SubscriptionMessaging';
import TransactionsGarbageCollect from 'containers/TransactionsGarbageCollect';
import * as appActions from 'data/app/actions';
import Bugsnag from 'utils/bugsnag';
import Cobrowse from 'utils/cobrowse';
import Hotjar from 'utils/hotjar';
import Intercom from 'utils/intercom';
import Pendo from 'utils/pendo';
import trackEventTTI from 'utils/trackEventTTI';

const logger = getLogger('Services');

const Services = () => {
  const dispatch = useDispatch();
  useThrottleFn(() => dispatch(appActions.appRefreshAll(undefined, { context: 'init' })), 1000, []);

  useEffect(() => {
    const loadTime = performance.now();
    logger.log(`Page load time is ${loadTime}ms`);
    tracker.track(tracker.events.load, { ...performance?.timing, $duration: loadTime / 1000 });
  }, []);

  const { pathname } = useLocation();
  useEffect(() => {
    const name = document.title;
    const tag = pathname.replace(/\/\d+(?=\/|$)/g, '/xxx');

    trackEventTTI(tracker.events.pageView, { tag, name });
  }, [pathname]);

  return (
    <>
      <ErrorBoundary>
        <TransactionsGarbageCollect />
      </ErrorBoundary>

      <React.StrictMode>
        <ErrorBoundary>
          <ShowPwaPrompts />
        </ErrorBoundary>
      </React.StrictMode>

      <ErrorBoundary>
        <Hotjar />
      </ErrorBoundary>

      <ErrorBoundary>
        <Notifications />
      </ErrorBoundary>

      <ErrorBoundary>
        <Intercom />
      </ErrorBoundary>

      <ErrorBoundary>
        <Cobrowse />
      </ErrorBoundary>

      <ErrorBoundary>
        <Pendo />
      </ErrorBoundary>

      <ErrorBoundary>
        <BumpConnector />
      </ErrorBoundary>

      <ErrorBoundary>
        <SubscriptionMessaging />
      </ErrorBoundary>

      <ErrorBoundary>
        <OfflineSnackbar />
      </ErrorBoundary>

      <ErrorBoundary>
        <BrowserMinVersion />
      </ErrorBoundary>

      <ErrorBoundary>
        <Bugsnag />
      </ErrorBoundary>

      <ErrorBoundary>
        <StorageAccessChecker />
      </ErrorBoundary>

      <ErrorBoundary>
        <AchievementsNotifier />
      </ErrorBoundary>

      <ErrorBoundary>
        <TransactionsTTI />
      </ErrorBoundary>

      <ErrorBoundary>
        <MobileDirectDialog />
      </ErrorBoundary>

      <ErrorBoundary>
        <ActionsSnackBar />
      </ErrorBoundary>

      <ErrorBoundary>
        <ContentSecurityPolicy />
      </ErrorBoundary>

      <ErrorBoundary>
        <UserIdle />
      </ErrorBoundary>

      <ErrorBoundary>
        <FutureTransactionGuidedPopover />
      </ErrorBoundary>
    </>
  );
};
export default Services;
